module.exports = __webpack_public_path__ + "03_glasses_brown.30dbb481.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer4/03_glasses_brown.png
// module id = 9osv
// module chunks = 0